import { BrowserModule } from '@angular/platform-browser';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormBuilder } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpModule } from '@angular/http';
import { JwtHelper } from 'angular2-jwt';
import { FileUploadModule } from 'ng2-file-upload';

import { AnalyticsModule, AnalyticsService } from './analytic.service';

import { AuthGuard } from './auth/auth.component';

import { AppComponent } from './app.component';
import { EditComponent } from './edit/edit.component';
import { ListComponent } from './list/list.component';
import { UploadComponent } from './upload/upload.component';
import { CurrencyPipe } from './currency.pipe';
import { PhonePipe } from './phone.pipe';
import { AuthComponent } from './auth/auth.component';
import { CreateComponent } from './create/create.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { GenerateComponent } from './generate/generate.component';
import { ViewComponent } from './view/view.component';

import 'rxjs/add/operator/map';
import { FrontComponent } from './front/front.component';
import { BackComponent } from './back/back.component';

export const routes = [
    { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
    { path: 'view/:id', component: ViewComponent, canActivate: [AuthGuard] },
    { path: 'create', component: CreateComponent, canActivate: [AuthGuard] },
    { path: 'generate/:id', component: GenerateComponent, canActivate: [AuthGuard] },
    { path: 'sign-in', component: AuthComponent },
    { path: '', pathMatch: 'full', redirectTo: 'dashboard' }
];

@NgModule({
  declarations: [
    AppComponent,
    EditComponent,
    ListComponent,
    UploadComponent,
    CurrencyPipe,
    PhonePipe,
    AuthComponent,
    CreateComponent,
    DashboardComponent,
    GenerateComponent,
    ViewComponent,
    FrontComponent,
    BackComponent
  ],
  imports: [
    BrowserModule,
    HttpModule,
    RouterModule.forRoot(routes),
    ReactiveFormsModule,
    FileUploadModule
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    AnalyticsService,
    AuthGuard,
    JwtHelper,
    FormBuilder
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts